import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
};

export const schemaUserResolverGetRepresentedUsers = z.array(
    UsersTableDefinitionZod.pick({
        absence: true,
        firstName: true,
        id: true,
        lastName: true,
    }).extend({
        // manual delegation (e.g. set by the team leader), independent of any absence
        delegation: z
            .object({
                appointedAt: z.coerce.date(),
                appointedByName: z.string().nullable(),
            })
            .nullable(),
    }),
);

export type SchemaUserResolver_GetRepresentedUsers = z.infer<typeof schemaUserResolverGetRepresentedUsers>;

export type UserResolver_GetRepresentedUsers = Resolver<Arguments, SchemaUserResolver_GetRepresentedUsers>;
